"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@requestnetwork/types");
const reference_based_1 = require("../reference-based");
const CURRENT_VERSION = '0.1.0';
/**
 * Implementation of the payment network to pay in ERC20 based on a reference provided to a proxy contract.
 */
class Erc20ProxyPaymentNetwork extends reference_based_1.default {
    constructor(currencyManager) {
        super(currencyManager, types_1.ExtensionTypes.PAYMENT_NETWORK_ID.ERC20_PROXY_CONTRACT, CURRENT_VERSION, types_1.RequestLogicTypes.CURRENCY.ERC20);
    }
}
exports.default = Erc20ProxyPaymentNetwork;
